import React from 'react';
import { Row, Col, Input } from 'reactstrap';
import { T } from '../../../traks';

export const AddressForm = ({ updateField, values, errors, countryList, isLoading }) => {
  return (
    <React.Fragment>
      <Row className="mt-2">
        <Col>
          <label><T>Phone Number *</T></label>
          <Input
            type="text"
            value={values.phoneNumber}
            onChange={(e) => updateField('phoneNumber', e.target.value)}
            disabled={isLoading}
          />
          {errors.phoneNumber && <span className="text-danger form-error">{errors.phoneNumber}</span>}
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <label><T>Country *</T></label>
          <Input
            type="select"
            value={values.country}
            onChange={(e) => updateField('country', e.target.value)}
            disabled={isLoading}
          >
            <option value=""></option>
            {countryList.map((countryItem, index) => (
              <option key={index} value={countryItem.value}>
                {countryItem.label}
              </option>
            ))}
          </Input>
          {errors.country && <span className="text-danger form-error">{errors.country}</span>}
        </Col>
      </Row>
      <Row className="mt-2">
        <Col sm={4}>
          <label><T>Postal code *</T></label>
          <Input
            type="text"
            value={values.postalCode}
            onChange={(e) => updateField('postalCode', e.target.value)}
            disabled={isLoading}
          />
          {errors.postalCode && <span className="text-danger form-error">{errors.postalCode}</span>}
        </Col>
        <Col sm={8}>
          <label><T>City *</T></label>
          <Input
            type="text"
            value={values.city}
            onChange={(e) => updateField('city', e.target.value)}
            disabled={isLoading}
          />
          {errors.city && <span className="text-danger form-error">{errors.city}</span>}
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <label><T>Street Address *</T></label>
          <Input
            type="text"
            value={values.streetAddress}
            onChange={(e) => updateField('streetAddress', e.target.value)}
            disabled={isLoading}
          />
          {errors.streetAddress && <span className="text-danger form-error">{errors.streetAddress}</span>}
        </Col>
      </Row>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Checkout/AddressForm.js